import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../../components/Header';
import CrudBar from '../../../components/Systema/Crud/CrudBar';
import CrudRouter from '../../../components/Systema/Crud/CrudRouter';
import SimplePaginatedTable from '../../../components/Systema/Data/SimplePaginatedTable';
import CadastroNotificacaoForm from './form';
import service from './service';

const CHANNEL_LABELS = {
  all: 'Todos',
  SiorconpAPI: 'Siorconp',
  SGRH_API: 'SGRH',
};

const SEVERITY_LABELS = {
  INFO: 'Informação',
  CRITICAL: 'Crítica',
  WARNING: 'Aviso',
};

function formatDate(value) {
  if (!value) return '-';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return date.toLocaleDateString('pt-BR');
}

const columns = [
  { header: 'Título', property: 'title' },
  {
    header: 'Canal',
    property: 'channel',
    format: (value) => CHANNEL_LABELS[value] || value || '-',
  },
  {
    header: 'Severidade',
    property: 'severity',
    format: (value) => SEVERITY_LABELS[value] || value || '-',
  },
  {
    header: 'Cliente',
    property: 'cliente.nome',
  },
  {
    header: 'Criado em',
    property: 'createdAt',
    format: formatDate,
  },
  {
    header: 'Expira em',
    property: 'expiresAt',
    format: formatDate,
  },
];

export default function CadastroNotificacaoPage() {
  const [selected, setSelected] = useState(null);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState({ createdAt: 'DESC' });

  return (
    <Container fluid>
      <Header>Cadastro de Notificações</Header>
      <CrudRouter form={CadastroNotificacaoForm} service={service}>
        <CrudBar selected={selected} />
        <SimplePaginatedTable
          service={service}
          columns={columns}
          limit={20}
          page={page}
          setPage={setPage}
          sort={sort}
          onSort={setSort}
          selected={selected}
          onSelect={setSelected}
          className='table-sm'
        />
      </CrudRouter>
    </Container>
  );
}
